export default __webpack_public_path__ + "d58aa22.png";